import React from 'react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function PainPoints() {
  return <section className="w-full bg-gray-50 py-12 md:py-16 px-4" data-id="element-247">
      <div className="max-w-2xl mx-auto" data-id="element-248">
        <h2 className="text-2xl md:text-3xl font-black font-heading text-gray-900 text-center mb-8" data-id="element-249">
          Si eres mamá o papá, esto te va a sonar familiar:
        </h2>

        <div className="space-y-4 mb-10" data-id="element-250">
          <div className="bg-white rounded-xl p-4 flex items-start gap-3 shadow-sm border border-red-100" data-id="element-251">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-252">❌</span>
            <p className="text-gray-800 font-body text-base md:text-lg" data-id="element-253">
              Tu hijo no para, se distrae o parece no escuchar nunca
            </p>
          </div>

          <div className="bg-white rounded-xl p-4 flex items-start gap-3 shadow-sm border border-red-100" data-id="element-254">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-255">❌</span>
            <p className="text-gray-800 font-body text-base md:text-lg" data-id="element-256">
              Sientes que todo termina en gritos o frustración
            </p>
          </div>

          <div className="bg-white rounded-xl p-4 flex items-start gap-3 shadow-sm border border-red-100" data-id="element-257">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-258">❌</span>
            <p className="text-gray-800 font-body text-base md:text-lg" data-id="element-259">
              Las rutinas no funcionan y cada día es un caos
            </p>
          </div>

          <div className="bg-white rounded-xl p-4 flex items-start gap-3 shadow-sm border border-red-100" data-id="element-260">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-261">❌</span>
            <p className="text-gray-800 font-body text-base md:text-lg" data-id="element-262">
              Las pantallas son la única forma de "calmarlo"
            </p>
          </div>

          <div className="bg-white rounded-xl p-4 flex items-start gap-3 shadow-sm border border-red-100" data-id="element-263">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-264">❌</span>
            <p className="text-gray-800 font-body text-base md:text-lg" data-id="element-265">
              Te sientes culpable por no saber cómo ayudarlo
            </p>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-266">
          <p className="text-xl md:text-2xl font-black font-heading text-red-600 mb-6" data-id="element-267">
            ¿Cuánto tiempo más vas a seguir sintiéndote así?
          </p>

          <p className="text-gray-600 font-body text-base md:text-lg mb-4" data-id="element-268">
            Da igual si estás en México, Argentina, España, Colombia, Chile o
            cualquier país donde se hable español…
          </p>

          <div className="space-y-2 mt-6" data-id="element-269">
            <p className="text-lg md:text-xl font-bold text-gray-900 font-heading" data-id="element-270">
              👉 El problema es el mismo
            </p>
            <p className="text-lg md:text-xl font-bold text-gray-900 font-heading" data-id="element-271">
              👉 Y la solución también
            </p>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-272">
          <button onClick={scrollToPricing} className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl px-8 py-4 rounded-xl shadow-lg transition-colors duration-200 cursor-pointer font-heading" data-id="element-273">
            👉 QUIERO LA SOLUCIÓN AHORA
          </button>
        </div>
      </div>
    </section>;
}